export default __webpack_public_path__ + "static/media/searchengineimg.ba0e1ed0.png";